import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h4">403 Unauthorized</Typography>
      <Typography>You do not have permission to access this page.</Typography>
      <Button variant="contained" onClick={() => navigate("/")}>
        Go Dashboard
      </Button>
    </Box>
  );
}
